import { DateTime } from 'luxon';
import { columnFactory } from '@pebula/ngrid';
import { CitiService } from '@sg/api/citi-service';

export const SWIFT_FORWARDING_OUTBOUND_COLUMNS = columnFactory()
  .default({ reorder: false, resize: false })
  .table(
    { prop: 'formattedFileName', label: 'File name', width: '150px', resize: true, minWidth: 125, maxWidth: 150 },
    { prop: 'isin', headerType: 'asIs', label: 'ISIN', width: '100px' },
    { prop: 'forwardedDate', sort: true, label: 'Sent', width: '115px', transform: (value) => dateFormatter(value) },
    { prop: 'units', label: 'Units', width: '45px', type: 'number' },
    { prop: 'bic', headerType: 'asIs', label: 'BIC', width: '100px' },
    { prop: '_arrow_', label: '', width: '25px' }
  )
  .build();

export const SWIFT_FORWARDING_INBOUND_COLUMNS = columnFactory()
  .default({ reorder: false, resize: false })
  .table(
    { prop: 'name', label: 'File name', width: '275px', resize: true, minWidth: 250, maxWidth: 275 },
    {
      prop: 'insertDate',
      alias: 'Date',
      sort: true,
      label: 'Received on',
      width: '115px',
      transform: (value) => dateFormatter(value),
    },
    { prop: 'status', label: 'Status', width: '120px', transform: (value) => swiftStatusMapper[value] },
    { prop: '_arrow_', label: '', width: '25px' }
  )
  .build();

export const dateFormatter = (isoDate: string): string => {
  return DateTime.fromISO(isoDate).toFormat('dd/MM/yy, hh:mm a');
};

export const swiftStatusMapper: {
  [key in CitiService.InboundFileDto['status']]: string;
} = {
  New: 'notProcessed',
  Processing: 'notProcessed',
  Error: 'processedFailure',
  Processed: 'processedSuccess',
};
